import { useEffect, useState } from 'react';
import { maintenanceItemsApi } from '../buildingManagementApi';
import { MAINTENANCE_AGING } from '../buildingManagementTypes';
import { AGING_DOT } from './maintenanceCalendarDots';

/**
 * What a calendar dot means, in words, on the MONTH page — so a colour is never a fact only a
 * sighted reader who already knows the palette gets. The register's year view needs none: its
 * aging cards carry the same dots. Every entry also names its band in its own accessible name.
 *
 * The escalated band's label IS the threshold ("30 Days Expired"), so it waits for the settings
 * rather than inventing a word; a failed read leaves it out.
 */
export function MaintenanceCalendarLegend() {
  const [escalatedLabel, setEscalatedLabel] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    maintenanceItemsApi
      .settings(controller.signal)
      .then((next) => {
        if (!controller.signal.aborted) setEscalatedLabel(next.escalatedLabel);
      })
      .catch(() => undefined);

    return () => controller.abort();
  }, []);

  return (
    <ul className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-600">
      <Legend dot={AGING_DOT[MAINTENANCE_AGING.onSchedule]} label="On Schedule" />
      <Legend dot={AGING_DOT[MAINTENANCE_AGING.nearExpiration]} label="Near Expiration" />
      <Legend dot={AGING_DOT[MAINTENANCE_AGING.expired]} label="Expired" />
      {escalatedLabel ? <Legend dot={AGING_DOT[MAINTENANCE_AGING.expiredBeyondThreshold]} label={escalatedLabel} /> : null}
    </ul>
  );
}

function Legend({ dot, label }: { dot: string; label: string }) {
  return (
    <li className="inline-flex items-center gap-1.5">
      <span aria-hidden="true" className={`h-2 w-2 rounded-full ${dot}`} />
      {label}
    </li>
  );
}
